export const FETCH_CMS_ADS_REQUEST = "FETCH_CMS_ADS_REQUEST";
export const FETCH_CMS_ADS_SUCCESS = "FETCH_CMS_ADS_SUCCESS";
export const FETCH_CMS_ADS_FAILURE = "FETCH_CMS_ADS_FAILURE";

export const fetchAdsRequest = (page) => ({
  type: FETCH_CMS_ADS_REQUEST,
  payload: { page },
});

export const fetchAdsSuccess = (page, adsData) => ({
  type: FETCH_CMS_ADS_SUCCESS,
  payload: { page, adsData },
});

export const fetchAdsFailure = (page, error) => ({
  type: FETCH_CMS_ADS_FAILURE,
  payload: { page, error },
});
